import { authStatus, GetproductVarient } from '../action/Status';

const initialData = {
	users: [],
	profile: [],
	allProduct: [],
	cart: [],
	variantData: [],
	loginPopMsg: null,
};

const reducer = (state = initialData, action) => {
	switch (action.type) {
		case authStatus.LOGIN_REQUEST:
			return {
				...state,
				loginPopMsg: false,
				users: [],
			};

		case authStatus.LOGIN_POPUP:
			return {
				...state,
				loginPopMsg: true,
			};

		case authStatus.LOGIN_SUCCESS:
			return {
				...state,
				users: action.payload.data,
			};

		case authStatus.LOGIN_FAILED:
			return {
				...state,
				users: action.payload.data,
			};

		case authStatus.LOGIN_POPUP_CLOSE:
			return {
				...state,
				loginPopMsg: false,
			};

		case authStatus.REG_REQUEST:
			return {
				...state,
				users: [],
			};

		case authStatus.REG_SUCCESS:
			return {
				...state,
				users: action.payload.data,
			};

		case authStatus.PRODUCT_REQUEST:
			return {
				...state,
			};

		case authStatus.PRODUCT_SUCCESS:
			return {
				...state,
				allProduct: action.payload.data,
			};

		case authStatus.CART_REQUEST:
			return {
				...state,
			};

		case authStatus.CART_SUCCESS:
			return {
				...state,
				// Uncomment the following line if cartData should be updated
				// cart: action.payload.cartData,
			};

		case authStatus.GET_CART_REQUEST:
			return {
				...state,
			};

		case authStatus.GET_CART_SUCCESS:
			return {
				...state,
				cart: action.payload.cartData,
			};

		case GetproductVarient.VARIANT_SUCCESS:
			return {
				...state,
				variantData: action.payload.variantData,
			};

		case authStatus.LOGOUT_REQUEST:
			return {
				...state,
			};

		case authStatus.LOGOUT_SUCCESS:
			return {
				...initialData,
			};

		case authStatus.LOGOUT_FAILURE:
			return {
				...state,
				error: action.payload.error,
			};

		case authStatus.PROFILE_GET_REQUEST:
			return {
				...state,
				loginPopMsg: false,
			};

		case authStatus.PROFILE_GET_SUCCESS:
			return {
				...state,
				profile: action.payload.data,
			};

		case authStatus.PROFILE_GET_FAILURE:
			return {
				...state,
				profile: action.payload.data,
			};

		default:
			return state;
	}
};

export default reducer;
